import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import store from "../../../redux/store";
import { actions } from "../../../redux/actions";
import { LogoutIcon } from "../../../shared/icons/Icons";
import { logout } from "../../../shared/settings/auth";
import { APP_LOGO_PATH } from "../../../shared/settings/config";

import "./UserProfile.scss";

export default function UserProfile() {
    const dispatch = useDispatch();
    const history = useHistory();

    const loggedInUserData = useSelector((state) => state.user);
    const userRole = loggedInUserData?.role || loggedInUserData?.user_type || loggedInUserData?.type || loggedInUserData?.userRole;

    const handleLogout = () => {
        store.dispatch(actions.setUser(null));
        logout(history);
    };

    return (
        <div className="user-profile-page">
            <div className="profile-card">
                <div className="profile-header">
                    <div className="profile-avatar">
                        {loggedInUserData.first_name?.charAt(0)?.toUpperCase()}{loggedInUserData.last_name?.charAt(0)?.toUpperCase() || 'SG'}
                    </div>
                    <h2 className="profile-name">
                        {loggedInUserData.first_name && loggedInUserData.last_name
                            ? `${loggedInUserData.first_name} ${loggedInUserData.last_name}`
                            : 'User'}
                    </h2>
                    <p className="profile-email">{loggedInUserData.email || 'user@quantsynx.com'}</p>
                    <span className="profile-role-badge">{userRole || 'N/A'}</span>
                </div>

                <div className="profile-details">
                    <h3 className="details-title">Account Information</h3>
                    
                    <div className="table-responsive">
                        <table className="profile-table">
                            <tbody>
                                <tr>
                                    <td className="table-label">First Name</td>
                                    <td className="table-value">{loggedInUserData.first_name || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td className="table-label">Last Name</td>
                                    <td className="table-value">{loggedInUserData.last_name || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td className="table-label">Email</td>
                                    <td className="table-value">{loggedInUserData.email || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td className="table-label">Role</td>
                                    <td className="table-value">{userRole || 'N/A'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}